const retryErrorCodes = [
  500, // internal server error
  502, // bad gateway
  503, // service unavailable
  504, // gateway timeout
  429, // too many requests
];

const waitFor = async (delay: number) => {
  await new Promise((resolve) => setTimeout(resolve, delay));
};

export async function fetchWithRetry(
  url: string,
  options: RequestInit = {},
  retries: number = 3,
  delay: number = 500
): Promise<Response> {
  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      if (retries > 0 && retryErrorCodes.includes(response.status)) {
        console.log(`Request ${url} failed with ${response.status}, will try again in ${delay}ms`);
        await waitFor(delay);
        return fetchWithRetry(url, options, retries - 1, delay * 2);
      } else {
        return response;
      }
    }

    return response;
  } catch (error) {
    if (retries > 0) {
      console.log(
        `Request ${url} failed with error: ${error.message}, will try again in ${delay}ms`
      );
      await waitFor(delay);
      return fetchWithRetry(url, options, retries - 1, delay * 2);
    }
    throw error; // If no more retries left, throw the error
  }
}
